const getLocalStorage = () => {
  try {
    return localStorage
  } catch {
    return undefined
  }
}

export default getLocalStorage
